const moeny = "Rp";
export default{
    moeny
} 